import { addMinutes, format, subMinutes } from "date-fns";
var changeTimeByTimezoneOffset = function(date) {
    var offset = date.getTimezoneOffset();
    return Math.sign(offset) !== -1 ? addMinutes(date, offset) : subMinutes(date, Math.abs(offset));
};
export var formatDateTime = function(date) {
    var withMilliseconds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var dateToFormat = typeof date === "string" ? new Date(date) : date;
    return format(dateToFormat, "yyyy-MM-dd HH:mm:ss".concat(withMilliseconds ? ".SSS" : ""));
};
export var formatDateTimeISO = function(date) {
    var dateUTC = changeTimeByTimezoneOffset(date);
    return format(dateUTC, "yyyy-MM-dd'T'HH:mm:ss'Z'");
};

//# sourceMappingURL=date-time.js.map